import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CarouselVesselCardComponent } from './carousel-vessel-card.component';
import { SwiperCarouselModule } from '../swiper-carousel/swiper-carousel.module';
import { MatIconModule } from '@angular/material/icon';
import { RoundDownPipe } from '../../pipes/roundDown.pipe';
import { VesselTotalPriceDialogComponent } from './vessel-total-price-dialog/vessel-total-price-dialog.component';
import { VesselTotalPriceDialogModule } from './vessel-total-price-dialog/vessel-total-price-dialog.module';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';

@NgModule({
  imports: [
    CommonModule,
    SwiperCarouselModule,
    MatIconModule,
    VesselTotalPriceDialogModule,
    MatBottomSheetModule,
  ],
  entryComponents: [VesselTotalPriceDialogComponent],
  exports: [CarouselVesselCardComponent, RoundDownPipe],
  declarations: [CarouselVesselCardComponent, RoundDownPipe],
})
export class CarouselVesselCardModule {}
